import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment.development';

export interface Attorney {
    id?: number;
    user_id?: number;
    firm_name: string;
    attorney_name: string | null;
    first_name?: string | null;
    last_name?: string | null;
    attorney_email: string;
    attorney_phone: string;
    firm_address: string;
    city?: string | null;
    state?: string | null;
    zip_code?: string | null;
    country?: string | null;
    profile_image_path?: string | null;
    preferred_contact: string;
    created_at?: string;
    updated_at?: string;
    user?: { id: number; status: string };
}

@Injectable({
    providedIn: 'root'
})
export class AttorneyService {
    private apiUrl = `${environment.apiUrl}/api/attorneys`;

    constructor(private http: HttpClient) { }

    getAttorneys(): Observable<Attorney[]> {
        return this.http.get<Attorney[]>(this.apiUrl);
    }

    getAttorneyById(id: number | string): Observable<Attorney> {
        return this.http.get<Attorney>(`${this.apiUrl}/${id}`);
    }

    addAttorney(attorney: FormData | any): Observable<Attorney> {
        return this.http.post<Attorney>(this.apiUrl, attorney);
    }

    updateAttorney(id: number, attorney: FormData | any): Observable<Attorney> {
        return this.http.put<Attorney>(`${this.apiUrl}/${id}`, attorney);
    }

    deleteAttorney(id: number): Observable<any> {
        return this.http.delete(`${this.apiUrl}/${id}`);
    }

    toggleStatus(attorneyId: number, status: 'active' | 'deactive'): Observable<any> {
        return this.http.post(`${environment.apiUrl}/api/update_status`, { attorney_id: attorneyId, status });
    }
}
